"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diff = void 0;
const arraysMatch = (arr1, arr2, key, diffs) => {
    if (arr1.length !== arr2.length)
        return false;
    for (let i = 0; i < arr1.length; i++) {
        const type1 = Object.prototype.toString.call(arr1[i]);
        //check if array is an array of objects
        if (type1 === '[object Object]') {
            compare(arr1[i], arr2[i], key, diffs);
            if (Object.keys(diffs).length > 0)
                return false;
        }
        else if (arr1[i] !== arr2[i])
            return false;
    }
    return true;
};
const compare = (item1, item2, key, diffs) => {
    if (!item1 || !item2)
        return;
    const type1 = Object.prototype.toString.call(item1);
    const type2 = Object.prototype.toString.call(item2);
    if (type2 === '[object Undefined]') {
        diffs[key] = null;
        return;
    }
    if (type1 !== type2) {
        diffs[key] = item2;
        return;
    }
    if (type1 === '[object Object]') {
        const objDiff = (0, exports.diff)(item1, item2);
        if (Object.keys(objDiff).length > 0) {
            diffs[key] = objDiff;
        }
        return;
    }
    if (type1 === '[object Array]') {
        if (!arraysMatch(item1, item2, key, diffs)) {
            diffs[key] = item2;
        }
        return;
    }
    if (type1 === '[object Function]') {
        if (item1.toString() !== item2.toString()) {
            diffs[key] = item2;
        }
    }
    else {
        if (item1 !== item2) {
            diffs[key] = item2;
        }
    }
};
/**
 *
 * @param obj1
 * @param obj2
 * finds fields that exists in both objects and that have changed.
 * outputs the diff values that exist in object 2.
 */
const diff = (obj1, obj2) => {
    if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
        return obj1;
    }
    const diffs = {};
    let key;
    for (key in obj1) {
        if (obj1.hasOwnProperty(key)) {
            compare(obj1[key], obj2[key], key, diffs);
        }
    }
    for (key in obj2) {
        if (obj2.hasOwnProperty(key)) {
            if (!obj1[key] && obj1[key] !== obj2[key]) {
                diffs[key] = obj2[key];
            }
        }
    }
    return diffs;
};
exports.diff = diff;
//# sourceMappingURL=object-diff.js.map